export const BASE_IP = process.env.REACT_APP_BASE_IP;
export const BASE_PORT = process.env.REACT_APP_BASE_PORT;

const isDevelopment = process.env.NODE_ENV === "development";

export const BASE_URL = isDevelopment ? `http://${BASE_IP}:${BASE_PORT}/api` : `https://${BASE_IP}/api`;
export const PROFILE_URL = isDevelopment
    ? `http://${BASE_IP}:3000`
    : `https://${BASE_IP}`;
